import { Component, computed, input } from '@angular/core';
import { MatTooltip } from '@angular/material/tooltip';
import { IncidentSeverity } from '@models';

@Component({
  imports: [MatTooltip],
  selector: 'avs-incident-severity-count',
  styleUrl: './incident-severity-count.component.scss',
  template: `
    <span
      class="severity-block"
      [matTooltip]="isMinor() ? 'Minor' : 'Critical and Major'"
      [class.severity-critical]="isCriticalOrMajor()"
      [class.severity-minor]="isMinor()"
    >
      {{ amount() }}
    </span>
  `,
})
export class IncidentSeverityCountComponent {
  severity = input.required<IncidentSeverity>();
  amount = input(0);

  protected isCriticalOrMajor = computed(() =>
    [IncidentSeverity.CRITICAL, IncidentSeverity.MAJOR].includes(this.severity()),
  );

  protected isMinor = computed(() => this.severity() === IncidentSeverity.MINOR);
}
